import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { AccountPaidThroughStateClass } from './interfaces/paidThroughStateClass';
const initialState: AccountPaidThroughStateClass = {
    isLoading: false,
    status: 'idle',
    paidThroughList: [],
    selectedRecord: {},
    isReload: false
}
interface IThunkApi {
    state: {
        paidThrough: AccountPaidThroughStateClass;
    },
}
export const getAccountPaidThroughAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'paidThrough/getAccountPaidThrough',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/PaidThrough', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
    export const getAccountPaidThroughByIAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'paidThrough/getAccountPaidThroughById',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/PaidThrough/GetDataByAccountPaidThroughId/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const addPaidThroughAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'paidThrough/addPaidThrough',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PaidThrough/', 'POST', arg, true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

export const updatePaidThroughAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'paidThrough/updatePaidThrough',
        async (arg, thunkApi) => {
            const { AccountPaidThroughId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/PaidThrough/' + AccountPaidThroughId, 'POST', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deletePaidThroughAsyc = createAsyncThunk
    <any, any, IThunkApi>
    (
        'paidThrough/deletePaidThrough',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PaidThrough/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAllSelectedRecordPaidThroughAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "paidThrough/deleteAllSelectedRecordPaidThrough",
        async(arg,thunkApi) =>{
            const response = await fetchAPI('api/v2/PaidThrough/DeleteAllSelectedRecordPaidThrough', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        }
    )



export const paidThroughSlice = createSlice({
    name: 'paidThrough',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.paidThroughList.findIndex((item) => item.AccountPaidThroughId == action.payload);
            const newArray = [...state.paidThroughList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.paidThroughList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.paidThroughList.findIndex((item) => item.AccountPaidThroughId == action.payload);
            const newArray = [...state.paidThroughList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.paidThroughList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.paidThroughList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.paidThroughList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.paidThroughList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.paidThroughList = newArray;
        },
      
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountPaidThroughAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountPaidThroughAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.paidThroughList = payload.Data;
                state.paidThroughList.map((item: any) => {
                    item.isSelected = 0
                });
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
               
            })
            .addCase(getAccountPaidThroughAsync.rejected, (state) => {
                state.status = 'failed';
            })
          
            .addCase(getAccountPaidThroughByIAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountPaidThroughByIAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload[0][0];
            })
            .addCase(getAccountPaidThroughByIAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addPaidThroughAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addPaidThroughAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(addPaidThroughAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updatePaidThroughAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatePaidThroughAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(updatePaidThroughAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deletePaidThroughAsyc.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletePaidThroughAsyc.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(deletePaidThroughAsyc.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAllSelectedRecordPaidThroughAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAllSelectedRecordPaidThroughAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(deleteAllSelectedRecordPaidThroughAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }
})
export const {
    resetSelectedRecordObjectInState,
    checkedState, unCheckedState, checkedAllState, unCheckedAllState
} = paidThroughSlice.actions
export const paidThroughState = (state: RootState) => state.paidThrough
export default paidThroughSlice.reducer